module.exports = __webpack_public_path__ + "img/quizz.a668c3e9.jpg";